import { createPatchAPI } from '@cuemath/rest-api';

import { BASE_URL } from '../constants/api';

const { usePatch: useChangeParentPatch } = createPatchAPI({
  getURL: studentId => `${BASE_URL}/students/${studentId}/`,
});

export { useChangeParentPatch };
